<template>
  <div class="auth-page">
    <div class="page-toolbar">
      <div class="toolbar-left">
        <span style="color:#999;">共 {{ total }} 条待处理注销申请</span>
      </div>
      <div class="toolbar-right">
        <a-button icon="reload" @click="loadData">刷新</a-button>
      </div>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading"
      :pagination="pagination" @change="handleTableChange" size="middle">
      <span slot="person" slot-scope="text, record">
        <div class="cell-name">{{ record.realName || record.nickname || '未填写' }}</div>
        <div class="cell-sub">{{ record.mobile || '' }} · {{ record.jiangkNo || '' }}</div>
      </span>
      <span slot="reason" slot-scope="text, record">
        {{ record.cancelReason || '未填写原因' }}
      </span>
      <span slot="time" slot-scope="text, record">{{ record.cancelRequestAt || '—' }}</span>
      <span slot="action" slot-scope="text, record">
        <a-popconfirm title="确认注销该账号？历史数据将保留但账号禁用、认证失效。" @confirm="review(record, true)">
          <a style="color:#FF4D4F;">确认注销</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a-popconfirm title="驳回该注销申请？" @confirm="review(record, false)">
          <a>驳回</a>
        </a-popconfirm>
      </span>
    </a-table>
  </div>
</template>

<script>
import { getCancelRequests, reviewCancelRequest } from '@/api'

export default {
    name: 'CancelReview',
    data() {
        return {
            data: [],
            total: 0,
            loading: false,
            query: { page: 1, size: 20 },
            pagination: { current: 1, pageSize: 20, showSizeChanger: true, showTotal: t => `共 ${t} 条` },
            columns: [
                { title: '用户', dataIndex: 'person', scopedSlots: { customRender: 'person' }, width: 200 },
                { title: '注销原因', dataIndex: 'reason', scopedSlots: { customRender: 'reason' } },
                { title: '申请时间', dataIndex: 'time', scopedSlots: { customRender: 'time' }, width: 170 },
                { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 170 }
            ]
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            getCancelRequests({ ...this.query }).then(res => {
                const data = res.data || {}
                this.data = data.list || []
                this.total = data.total || 0
            }).finally(() => { this.loading = false })
        },
        handleTableChange(pagination) {
            this.query.page = pagination.current
            this.query.size = pagination.pageSize
            this.pagination = pagination
            this.loadData()
        },
        review(record, approve) {
            reviewCancelRequest({ userId: record.id, approve }).then(res => {
                this.$message.success(res.msg || (approve ? '已确认注销' : '已驳回'))
                this.loadData()
            }).catch(err => {
                this.$message.error((err && err.msg) || '操作失败')
            })
        }
    }
}
</script>

<style scoped>
.cell-name {
    font-weight: 600;
}
.cell-sub {
    font-size: 12px;
    color: #999;
}
</style>
